<div class="box">
  <div class="box-row header">
    <app-header-bar [title]="'licenses.title'"></app-header-bar>
  </div>

  @if (error) {
    <app-error [error]="error"></app-error>
  }

  @if (loading) {
    <!-- Skeleton / placeholder view while licenses are loading -->
    <h2 class="placeholder-glow">
      <span class="placeholder col-4"></span>
    </h2>

    <div class="accordion" aria-busy="true" aria-live="polite">
      @for (_ of [0, 1, 2, 3, 4, 5, 6, 7]; track _) {
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              disabled
              aria-disabled="true"
            >
              <span class="placeholder-glow w-100">
                <span class="placeholder col-6"></span>
                <span class="placeholder col-2 ms-2"></span>
              </span>
            </button>
          </h2>
        </div>
      }
    </div>

    <h2 class="mt-4 placeholder-glow">
      <span class="placeholder col-4"></span>
    </h2>

    <div class="accordion" aria-busy="true" aria-live="polite">
      @for (_ of [0, 1, 2, 3, 4]; track _) {
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              disabled
              aria-disabled="true"
            >
              <span class="placeholder-glow w-100">
                <span class="placeholder col-5"></span>
                <span class="placeholder col-2 ms-2"></span>
              </span>
            </button>
          </h2>
        </div>
      }
    </div>
  }

  @if (!loading && serverLicenses.length > 0) {
    <h2>{{ 'licenses.server' | translate }} ({{ serverDependenciesCount }})</h2>
    <div class="accordion">
      @for (license of serverLicenses; track license; let i = $index) {
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              [attr.data-bs-target]="'#licenses-server-' + i"
              aria-expanded="false"
              [attr.aria-controls]="'licenses-server-' + i"
            >
              {{ license.name }} ({{ license.dependencies.length }})
            </button>
          </h2>
          <div
            [id]="'licenses-server-' + i"
            class="accordion-collapse collapse"
          >
            <div class="accordion-body">
              <ul>
                @for (dependency of license.dependencies; track dependency) {
                  <li>
                    {{ dependency.group }}:{{ dependency.name }}:{{
                      dependency.version
                    }}
                    @if (dependency.licenseUrl) {
                      (<a href="{{ dependency.licenseUrl }}" target="_blank">{{
                        'licenses.license' | translate
                      }}</a
                      >)
                    }
                  </li>
                }
              </ul>
            </div>
          </div>
        </div>
      }
    </div>
  }

  @if (!loading && clientLicenses.length > 0) {
    <h2 class="mt-4">
      {{ 'licenses.client' | translate }} ({{ clientDependenciesCount }})
    </h2>

    <div class="accordion">
      @for (license of clientLicenses; track license; let i = $index) {
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              [attr.data-bs-target]="'#licenses-client-' + i"
              aria-expanded="false"
              [attr.aria-controls]="'licenses-client-' + i"
            >
              {{ license.name }} ({{ license.dependencies.length }})
            </button>
          </h2>
          <div
            [id]="'licenses-client-' + i"
            class="accordion-collapse collapse"
          >
            <div class="accordion-body">
              <ul>
                @for (dependency of license.dependencies; track dependency) {
                  <li>
                    @if (dependency.group) {
                      {{ dependency.group }}:{{ dependency.name }}:{{
                        dependency.version
                      }}
                    } @else {
                      {{ dependency.name }}:{{ dependency.version }}
                    }
                    @if (dependency.licenseUrl) {
                      (<a href="{{ dependency.licenseUrl }}" target="_blank">{{
                        'licenses.license' | translate
                      }}</a
                      >)
                    }
                  </li>
                }
              </ul>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
